module.exports = __webpack_public_path__ + "static/media/Jelani_Mobile.a58009fa.jpg";